import { IKnoAdminLevelSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnoAdminLevelSelectOption';

import { IKnmFilterFormBooleanSelectOption } from '../interfaces/IKnmFilterFormBooleanSelectOption';

export const knmFilterFormOnlyTrueSelectOptions: IKnmFilterFormBooleanSelectOption[] = [
  {
    id: 0,
    label: 'Да',
    value: true,
  },
];

export const knmFilterFormBooleanSelectOptions: IKnmFilterFormBooleanSelectOption[] = [
  {
    id: 0,
    label: 'Да',
    value: true,
  },
  {
    id: 1,
    label: 'Нет',
    value: false,
  },
];

export const knmFilterFormApprovedSelectOptions: IKnmFilterFormBooleanSelectOption[] = [
  {
    id: 0,
    label: 'Согласовано',
    value: true,
  },
  {
    id: 1,
    label: 'Не согласовано',
    value: false,
  },
];

export const knmFilterFormSignedSelectOptions: IKnmFilterFormBooleanSelectOption[] = [
  {
    id: 0,
    label: 'Подписано',
    value: true,
  },
  {
    id: 1,
    label: 'Не подписано',
    value: false,
  },
];

export const knmFilterFormNotifyLateSelectOptions: IKnmFilterFormBooleanSelectOption[] = [
  {
    id: 0,
    label: 'Нет',
    value: false,
  },
  {
    id: 1,
    label: 'Да',
    value: true,
  },
  {
    id: 2,
    label: 'Отсутствует',
    value: false,
  },
];

export const noKnoOrganizationAdminLevelSelectOption: IKnoAdminLevelSelectOption = {
  id: 0,
  title: 'Отсутствует значение',
  description: 'Отсутствует значение',
  label: 'Отсутствует значение',
  value: 'Отсутствует значение',
};
